import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { ArticleCard } from "./ArticleCard";
import { ArrowRight } from "lucide-react";
import { getCategory } from "../lib/categories";

export default function CategoryBlock({ slug }) {
  const [items, setItems] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const c = getCategory(slug);

  useEffect(() => {
    api.get("/articles", { params: { category: slug, limit: 3 } })
      .then((r) => { setItems(r.data || []); setLoaded(true); })
      .catch(() => setLoaded(true));
  }, [slug]);

  if (loaded && items.length === 0) return null;
  if (!items.length) return null;

  return (
    <section className="my-14" data-testid={`category-block-${slug}`}>
      <div className="flex items-end justify-between mb-5">
        <div>
          <div className="font-outfit font-black uppercase tracking-widest text-xs bodh-text-gradient">{c.name_en}</div>
          <h2 className="mt-1 font-devanagari font-black text-2xl sm:text-3xl text-zinc-900">{c.name_hi}</h2>
        </div>
        <Link to={`/category/${slug}`} data-testid={`category-more-${slug}`} className="text-sm font-outfit font-bold text-zinc-700 hover:text-[#E30613] inline-flex items-center gap-1 bodh-link">
          और देखें <ArrowRight className="h-3.5 w-3.5" />
        </Link>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {items.slice(0, 3).map((a) => (
          <ArticleCard key={a.id} a={a} size="lg" />
        ))}
      </div>
    </section>
  );
}
